<template>
  <base-grid
    class="game-secondary-button-border-color game-tile-radius tw-overflow-hidden game-tile-border"
    :class="Classes.STATS"
    :cols="2"
    :x-gap="0"
    :y-gap="0"
  >
    <view-stat
      v-if="panelLoading || mod?.modfile?.filesize"
      icon="database"
      :title="$t('filesize')"
      :text="mod?.modfile?.filesize && humanFilesize(mod.modfile.filesize)"
      :panel-loading="panelLoading"
    />

    <view-stat
      icon="star"
      format-number
      :title="$t('subscribers')"
      :text="mod?.stats.subscribers_total"
      :panel-loading="panelLoading"
    />

    <view-stat
      icon="download"
      format-number
      :title="$t('downloads')"
      :text="mod?.stats.downloads_total"
      :panel-loading="panelLoading"
    />

    <view-stat
      icon="clock"
      format-number
      :title="`24h ${$t('downloads')}`"
      :text="mod?.stats.downloads_today"
      :panel-loading="panelLoading"
    />
  </base-grid>
</template>

<script>
import ViewStat from '@components/View/ViewStat.vue'
import { humanFilesize } from '@helpers/utils.js'
import Classes from '@shared/js/config/css.js'
export default {
  components: {
    ViewStat,
  },
  props: {
    mod: {
      type: Object,
      default: null,
    },
    game: {
      type: Object,
      default: null,
    },
    panelLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      humanFilesize,
      Classes,
    }
  },
}
</script>

<style>
.stats {
  div.section {
    border-bottom: var(--tile-border-width) solid var(--tile-border-color);
    border-right: var(--tile-border-width) solid var(--tile-border-color);
  }

  div.section:nth-child(2),
  div.section:nth-child(4) {
    border-right: none;
  }

  div.section:nth-child(3),
  div.section:nth-child(4) {
    border-bottom: none;
  }
}

@media screen and (min-width: 1000px) and (max-width: 1319px) {
  .stats div.section {
    > div {
      padding: 0.5rem;
    }

    &:nth-child(1),
    &:nth-child(2) {
      > div {
        padding-top: 1rem;
      }
    }

    &:nth-child(1),
    &:nth-child(3) {
      > div {
        padding-left: 1rem;
      }
    }

    &:nth-child(3),
    &:nth-child(4) {
      > div {
        padding-bottom: 1rem;
      }
    }

    &:nth-child(2),
    &:nth-child(4) {
      > div {
        padding-right: 1rem;
      }
    }
  }
}
</style>
